import { Text } from "@/components";
import clsx from "clsx";

export const Differences = () => {
  return (
    <div className="mx-auto container">
      <Text.Heading className="text-white md:px-[100px] text-center font-bold mb-4 md:mb-16">
        <span>
          The T12&nbsp;<span className="text-secondary">Difference</span>
        </span>
      </Text.Heading>

      <div className="flex flex-col gap-4 md:gap-12 xl:gap-[120px]">
        {[
          {
            title: "We are cap table experts",
            content: (
              <>
                Building the world’s most programatic cap table was the hard
                part... we definitely know how to use it and are happy to take
                the button pushing off of your plate.
              </>
            ),
            imgSrc: "/images/diff--cap-table-experts.png",
          },
          {
            title: "Cap Table Included",
            content: (
              <>
                Pay one fee, get everything you need.
                <br />
                <br />
                T12 Simulator
                <br />
                +Calculate dilution from note conversions
                <br />
                +Model out payouts under different exit scenarios
                <br />
                <br />
                Option Management
                <br />
                +Track vesting & share ownership in real time
                <br />
                +Control level of information shared
                <br />
                <br />
                Unlimited Use
                <br />
                +Unlimited T12 simulations
                <br />
                +Unlimited members/rounds
                <br />
              </>
            ),
            imgSrc: "/images/diff--cap-table-included.png",
          },
          {
            title: "Onboarding included",
            content: (
              <>
                Relax, put your feet up. Are you moving from spreadsheets or an
                existing cap table provider? No worries - we have you covered.
                <br />
                <br />
                We will onboard all of your data and cap table members.
                <br />
                <br />
                With T12's concierge onboarding you will be up in running in
                no-time.
              </>
            ),
            imgSrc: "/images/diff--onboarding-included.png",
          },
        ].map(({ title, content, imgSrc }, idx) => (
          <div className="grid lg:grid-cols-2 gap-8 lg:gap-10 xl:gap-16" key={idx}>
            <div
              className={clsx("flex items-center justify-center", {
                "lg:block": idx % 2 === 1,
                "lg:hidden": idx % 2 === 0,
              })}
            >
              <img
                className="w-4/5 md:w-3/4 lg:w-full h-auto"
                src={imgSrc}
                alt={title}
              />
            </div>

            <div className="flex flex-col justify-center gap-2 md:gap-6 lg:gap-8 xl:gap-12">
              <div className="text-3xl md:text-5xl text-center lg:text-left lg:text-[50px] font-bold text-white font-clashGrotesk">
                {title}
              </div>
              <div className="text-base md:text-xl lg:text-2xl leading-normal">
                {content}
              </div>
            </div>

            <div
              className={clsx("flex items-center justify-center", {
                "hidden lg:block": idx % 2 === 0,
                hidden: idx % 2 === 1,
              })}
            >
              <img src={imgSrc} alt={title} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
